import { http } from './config'

export default {
  
  getAllPackages: () => {
    return http.get('packages')
  },

  getFilteredPackages: (params) => {
    return http.get('packages', {params})
  },

  getPackageById: (packageID) => {
    return http.get('packages/' + packageID)
  },

  getPackageByName: (name) => {
    return http.get('packages/search_by_name/' + name)
  },

  createPackage: (packageParams) => {
    return http.post('packages', {
      name: packageParams.name,
      height: packageParams.height,
      weight: packageParams.weight,
      resistance: packageParams.resistance,
      ballast: packageParams.ballast,
      full_pallet: packageParams.full_pallet,
      units_per_box: packageParams.units_per_box,
      integration_id: packageParams.integration_id
    }
  )},

  updatePackage: (packageParams) => {
    return http.put('packages/' + packageParams.packageId, {
      name: packageParams.name,
      height: packageParams.height,
      weight: packageParams.weight,
      resistance: packageParams.resistance,
      ballast: packageParams.ballast,
      full_pallet: packageParams.full_pallet,
      units_per_box: packageParams.units_per_box,
      integration_id: packageParams.integration_id
    }
  )},

  deletePackage: (packageId) => {
    return http.delete('packages/' + packageId)
  },
}
